<template>
<div>
    <Breadcrumbs main="Admin" submain="Volunteer" title="Volunteer Detail" />
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6">
                <div class="text-right mb-4">
                    <button class="btn btn-primary btn-sm" @click="printCard">
                        <i class="fa fa-print mr-1"></i> Print ID Card
                    </button>
                </div>
                <div v-if="!loading && !error && volunteer" class="id-card">
                    <div class="id-card-header">
                        <img class="id-card-avatar" :src="host + volunteer.additional_info?.photo" alt="">
                        <div class="id-card-header-text">
                            <p class="id-card-name">{{ fullName }}</p>
                            <p class="id-card-email">{{ volunteer.user_object?.email }}</p>
                        </div>
                        <span class="id-card-badge">{{ volunteer.additional_info?.volunteer_id }}</span>
                    </div>

                    <div class="id-card-body">
                        <div class="id-card-fields">
                            <div class="field-row">
                                <div class="field-label">NID</div>
                                <div class="field-value">{{ volunteer.additional_info?.nid || '—' }}</div>
                            </div>
                            <div class="field-row">
                                <div class="field-label">Phone</div>
                                <div class="field-value">{{ volunteer.additional_info?.phone_number || '—' }}</div>
                            </div>
                            <div class="field-row">
                                <div class="field-label">Address</div>
                                <div class="field-value">{{ volunteer.additional_info?.address || '—' }}</div>
                            </div>
                            <div class="field-row">
                                <div class="field-label">Types</div>
                                <div>
                                    <b-badge
                                        v-for="(typ, index) in volunteer.additional_info?.type"
                                        :key="index"
                                        variant="primary"
                                        class="type-badge"
                                    >{{ typ.name }}</b-badge>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="field-label">Camp</div>
                                    <span v-if="volunteer.additional_info?.location">{{ volunteer.additional_info?.location?.name }}, </span>
                                    <span v-if="volunteer.additional_info?.location">{{ volunteer.additional_info?.location?.camp.camp_name }}, </span>
                                    <span v-if="volunteer.additional_info?.location">{{ volunteer.additional_info?.location?.area.area_name }}, </span>
                                    <span v-if="volunteer.additional_info?.location">{{ volunteer.additional_info?.location?.district.district_name }}, </span>
                                    <span v-if="volunteer.additional_info?.location">{{ volunteer.additional_info?.location?.country.country_name }}</span>
                            </div>
                        </div>

                        <div class="id-card-qr">
                            <img :src="qrSrc" v-if="qrSrc" alt="QR Code" width="150" height="150" />
                            <div class="qr-label">Scan to verify</div>
                        </div>
                    </div>

                </div>

                <div v-else class="card">
                    <div class="card-body text-center py-5">
                        <p class="text-muted mb-0">Loading volunteer details...</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import QRCode from 'qrcode'
import { myHost } from '../../../_helpers/host';

export default {
    name: 'VolunteerDetails',

    data() {
        return {
            host: myHost.host,
            volunteer: null,
            qrSrc: null
        }
    },

    computed: {
        ...mapState({
            details: state => state.volunteer.volunteerDetails,
            loading: state => state.volunteer.volunteerLoading,
            error: state => state.volunteer.volunteerError
        }),
        fullName() {
            if (!this.volunteer?.user_object) return ''
            const { first_name, last_name } = this.volunteer.user_object
            return `${first_name || ''} ${last_name || ''}`.trim()
        }
    },

    mounted() {
        this.$store.dispatch('volunteer/fetchVolunteerDetails', this.$route.params.id).then(() => {
            this.volunteer = this.details
            const volunteerId = this.volunteer?.additional_info?.volunteer_id
            if (volunteerId) {
                this.generate(String(volunteerId))
            }
        })
    },

    watch: {
        details(newDetails) {
            this.volunteer = newDetails
        }
    },

    methods: {
        printCard() {
            const card = document.querySelector('.id-card');
            const win = window.open('', '_blank', 'width=600,height=700');
            win.document.write(`
                <html>
                <head>
                    <title>Volunteer ID Card</title>
                    <style>
                        body { margin: 20px; font-family: sans-serif; }
                        .id-card { border-radius: 16px; border: 1px solid #dee2e6; overflow: hidden; background: #fff; max-width: 480px; margin: 0 auto; }
                        .id-card-header { background: #185FA5; padding: 18px 20px 14px; display: flex; align-items: center; gap: 14px; }
                        .id-card-avatar { width: 52px; height: 52px; border-radius: 50%; background: #E6F1FB; display: flex; align-items: center; justify-content: center; flex-shrink: 0; object-fit: cover; }
                        .id-card-header-text { flex: 1; }
                        .id-card-name { font-size: 17px; font-weight: 600; color: #E6F1FB; margin: 0 0 2px; }
                        .id-card-email { font-size: 14px; color: #e2eaf3; margin: 0; }
                        .id-card-badge { background: #0C447C; color: #e9f0f8; font-size: 13px; padding: 3px 10px; border-radius: 20px; white-space: nowrap; }
                        .id-card-body { display: flex; }
                        .id-card-fields { flex: 1; padding: 16px 20px; }
                        .id-card-qr { padding: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center; border-left: 1px solid #dee2e6; gap: 6px; }
                        .qr-label { font-size: 12px; color: #6c757d; text-align: center; }
                        .field-row { margin-bottom: 12px; }
                        .field-label { font-size: 12px; color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 2px; }
                        .field-value { font-size: 14px; font-weight: 500; color: #212529; }
                        .type-badge { margin-right: 4px; margin-bottom: 2px; font-size: 12px; }
                        .loc-item { font-size: 14px; color: #212529; margin-bottom: 3px; }
                        .id-card-footer { border-top: 1px solid #dee2e6; padding: 10px 20px; display: flex; justify-content: space-between; align-items: center; background: #f8f9fa; }
                        .footer-label { font-size: 11px; color: #6c757d; }
                        .footer-id { font-size: 13px; font-weight: 600; color: #212529; font-family: monospace; }
                    </style>
                </head>
                <body>
                    ${card.outerHTML}
                </body>
                </html>
            `);
            win.document.close();
            win.focus();
            setTimeout(() => {
                win.print();
                win.close();
            }, 500);
        },
    
        async generate(text) {
            try {
                this.qrSrc = await QRCode.toDataURL(text, { width: 120, margin: 1 })
            } catch (err) {
                console.error(err)
            }
        }
    }
}
</script>

<style scoped>
.id-card {
    border-radius: 16px;
    border: 1px solid #dee2e6;
    overflow: hidden;
    background: #fff;
}

.id-card-header {
    background: #185FA5;
    padding: 18px 20px 14px;
    display: flex;
    align-items: center;
    gap: 14px;
}

.id-card-avatar {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #E6F1FB;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    object-fit: cover;
}

.id-card-header-text { flex: 1; }

.id-card-name {
    font-size: 17px;
    font-weight: 600;
    color: #E6F1FB;
    margin: 0 0 2px;
}

.id-card-email {
    font-size: 14px;
    color: #e2eaf3;
    margin: 0;
}

.id-card-badge {
    background: #0C447C;
    color: #e9f0f8;
    font-size: 13px;
    padding: 3px 10px;
    border-radius: 20px;
    white-space: nowrap;
}

.id-card-body {
    display: flex;
}

.id-card-fields {
    flex: 1;
    padding: 16px 20px;
}

.id-card-qr {
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #dee2e6;
    gap: 6px;
}

.qr-label {
    font-size: 12px;
    color: #6c757d;
    text-align: center;
}

.field-row { margin-bottom: 12px; }

.field-label {
    font-size: 12px;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

.field-value {
    font-size: 14px;
    font-weight: 500;
    color: #212529;
}

.type-badge {
    margin-right: 4px;
    margin-bottom: 2px;
    font-size: 12px;
}

.loc-item {
    font-size: 14px;
    color: #212529;
    margin-bottom: 3px;
}
</style>